<div *ngIf="!notConnected || website?.domain_hash">
<db-cdn-notice [websiteId]="website?.id"></db-cdn-notice>
<div class="db-back-end">
  <div class="db-flex-box" [ngClass]="{'padding-bottom-backend': currentSubscription?.bundleClient || currentSubscription?.oneProductClient}">
    <div>
      <db-booster-optimization-status *ngIf="!currentSubscription?.trialBoosterClient && !(currentSubscription?.boosterProClient && website?.connectedFrom === 'speed_optimizer')"
                                      [websiteId]="website?.id"
                                      [userSubscription]="currentSubscription"
                                      [userSubscriptionType]="currentSubscription.type"
                                      [cacheEnabled]="cachingStatus"
                                      [isHosted]="!!website?.domain_hash"
                                      [adminActivateBoosterUrl]="website?.adminActivateBoosterUrl"
                                      [forHosting]="true"
                                      class="mb20"></db-booster-optimization-status>
      <db-cdn-enable-banner  [forHosting]="true" [websiteId]="website?.id" *ngIf="currentSubscription?.boosterProClient && !website?.domain_hash && (!currentSubscription?.plan?.additionalDomainCount || (currentSubscription?.plan?.additionalDomainCount && hostedCounts?.length === currentSubscription?.plan?.additionalDomainCount))"></db-cdn-enable-banner>
      <db-optimization-hosting  [websiteId]="website?.id" *ngIf="!website?.domain_hash && currentSubscription?.trialBoosterClient" ></db-optimization-hosting>
      <db-migrate-for-booster [currentSubscription]="currentSubscription" *ngIf="currentSubscription?.boosterProClient && !website?.domain_hash && hostedCounts?.length < currentSubscription?.plan?.additionalDomainCount "></db-migrate-for-booster>


      <db-benchmark class="mb30" [companyName]="companyName" [websiteId]="website?.id" [hostedCounts]="hostedCounts" [isHosted]="!!website?.domain_hash" [userSubscription]="currentSubscription" [user]="user" ></db-benchmark>

      <div class="db-hosting-add-on-migrate" *ngIf="currentSubscription?.boosterProClient && !website?.domain_hash && hostedCounts?.length < currentSubscription?.plan?.additionalDomainCount">
      <a class="ds-btn ds-btn-green ds-btn-l last" href="{{managerLink}}" download>
        <span>{{'text_download' | dbText | lowerCaseSpecificWords}}</span>
      </a>
      </div>
    </div>
  </div>
</div>
</div>

<div class="db-trouble-instructions" *ngIf="notConnected && !website?.domain_hash">
  <div>
    <db-booster-trouble-instructions [insideWebsite]="true" [website]="website" [currentSubscription]="currentSubscription"></db-booster-trouble-instructions>
  </div>
</div>
